import React from "react";
import { useTranslation } from "react-i18next";
import {
  ImmuneSystemHeader1,
  NutirentsBodyNeed,
  ImmuneSystemNutrientsHeader,
  FormulatedByExperts,
  ImmuneSystemVitaminD,
  ImmuneSystemVitaminDSecond,
  ImmuneSystemHeader,
  ImmuneSystemDescription,
  ImmuneSystemNutrientsHeader1,
  ImmuneSystemSelenium,
  ImmuneSystemSeleniumSecond,
  ImmuneSystemZinc,
  ImmuneSystemZincSecond,
  ImmuneSystemVitaminC,
  ImmuneSystemVitaminCSecond,
  ImmuneSystemDescription1,
  VitaminD,
  VitaminDDesc,
  Selenium,
  SeleniumDesc,
  Zinc,
  ZincDesc,
  VitaminC,
  VitaminCDesc,
  SupportImmuneSystem,
} from "../../Constants";
import ExpertSection from "../Customer/components/ExpertSection";
import MillionCombinations from "../Home/MillionCombinations";
import HighStandards from "../Home/HighStandards";
import ReviewsOverlay from "../Reviews";
import Unique from "../Home/Unique";
import SeleniumImg from "../../assets/focusareas/selenium-microgranules.webp";
import VitaminDImg from "../../assets/focusareas/vitamin-D3-microgranules.webp";
import VitaminCImg from "../../assets/focusareas/vitamin-C-microgranules.webp";
import ZincImg from "../../assets/focusareas/zinc-microgranules.webp";
import BannerMobile from "./components/BannerMobile";
import Description from "./components/Description";
import NutrientsMobile from "./components/NutrientsMobile";
import News from "./components/News";
import GlutenFree from "./components/GlutenFree";
import Banner from "./components/Banner";
import Nutrients from "./components/Nutrients";
import UniqueWeb from "./components/UniqueWeb";
import GlutenFreeWeb from "./components/GlutenFreeWeb";

const ImmuneSystem = () => {
  const { t } = useTranslation();

  const INGREDIENTS_DATA = [
    {
      title: t(VitaminD),
      desc: t(VitaminDDesc),
      img: VitaminDImg,
      details1: t(ImmuneSystemVitaminD),
      details2: t(ImmuneSystemVitaminDSecond),
    },
    {
      title: t(Selenium),
      desc: t(SeleniumDesc),
      img: SeleniumImg,
      details1: t(ImmuneSystemSelenium),
      details2: t(ImmuneSystemSeleniumSecond),
    },
    {
      title: t(Zinc),
      desc: t(ZincDesc),
      img: ZincImg,
      details1: t(ImmuneSystemZinc),
      details2: t(ImmuneSystemZincSecond),
    },
    {
      title: t(VitaminC),
      desc: t(VitaminCDesc),
      img: VitaminCImg,
      details1: t(ImmuneSystemVitaminC),
      details2: t(ImmuneSystemVitaminCSecond),
    },
  ];

  return (
    <div>
      <BannerMobile
        heading1={t(ImmuneSystemHeader)}
        heading2={t(ImmuneSystemHeader1)}
      />
      <div className="t-hidden md:t-block">
        <Banner
          heading1={t(ImmuneSystemHeader)}
          heading2={t(ImmuneSystemHeader1)}
          desc1={t(ImmuneSystemDescription)}
          desc2={t(ImmuneSystemDescription1)}
        />
        <Nutrients
          heading={t(NutirentsBodyNeed)}
          desc1={t(ImmuneSystemNutrientsHeader)}
          desc2={t(ImmuneSystemNutrientsHeader1)}
          data={INGREDIENTS_DATA}
        />

        <UniqueWeb />
        <GlutenFreeWeb />
      </div>
      <Description
        desc1={t(ImmuneSystemDescription)}
        desc2={t(ImmuneSystemDescription1)}
      />
      <NutrientsMobile
        heading={t(NutirentsBodyNeed)}
        desc1={t(ImmuneSystemNutrientsHeader)}
        desc2={t(ImmuneSystemNutrientsHeader1)}
        data={INGREDIENTS_DATA}
      />
      <div className="md:t-hidden">
        <Unique isFocusArea heading={t(SupportImmuneSystem)} />
      </div>
      <div>
        <MillionCombinations slug="/quiz" isFocusArea />
      </div>
      <section className="md:t-hidden t-flex t-items-center t-justify-center t-py-2 t-bg-gray-100 t-h-10">
        <ReviewsOverlay totalReviews={55} averageReviews={4.92} />
      </section>
      <div className="t-flex t-flex-col t-gap-4 t-p-4 t-max-w-[800px] !t-mx-auto">
        <h1 className="t-text-[24px] t-text-center">
          {t(FormulatedByExperts)}
        </h1>
        <ExpertSection />
      </div>
      <div>
        <HighStandards />
      </div>
      <GlutenFree />
      <News />
    </div>
  );
};

export default ImmuneSystem;
